import axios from "../../utils/axios";
import type { BrandingDTO, SaveBrandingRequest } from "../types/brandingDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchBranding = () => axios.get<BrandingDTO[]>(`${apiUrl}/Branding`);

// Resolved server-side: the site's own branding, else the account-wide one, else null.
const fetchBrandingForSite = (siteExternalId: string) =>
    axios.get<BrandingDTO | null>(`${apiUrl}/Branding/ForSite/${siteExternalId}`);

// The logo travels with the row, so the save is multipart rather than JSON.
const saveBranding = (branding: SaveBrandingRequest) => {
    const form = new FormData();

    if (branding.siteExternalId) form.append("siteExternalId", branding.siteExternalId);
    if (branding.primaryColour) form.append("primaryColour", branding.primaryColour);
    if (branding.secondaryColour) form.append("secondaryColour", branding.secondaryColour);
    form.append("isActive", String(branding.isActive));
    if (branding.logo) form.append("logo", branding.logo);
    if (branding.removeLogo) form.append("removeLogo", "true");

    return axios.post<BrandingDTO>(`${apiUrl}/Branding/Save`, form);
};

// The logo endpoint is authenticated, so it can't be an <img src> — fetch the
// blob and hand the caller an object URL instead.
const fetchLogo = (reference: string) =>
    axios.get<Blob>(`${apiUrl}/Branding/Logo/${reference}`, { responseType: "blob" });

const brandingService = {
    fetchBranding,
    fetchBrandingForSite,
    saveBranding,
    fetchLogo,
};

export default brandingService;
